export const MODAL_TYPE_UNFOLLOW_ALL_CATEGORIES = 'unfollow-all-categories';
